'use strict';

/**
 *
 * @name: PartialsRun
 *
 */

import FilterBoxTemplate from './templates/filter-box.html';
import FollowBoxSocialTemplate from './templates/follow-box-social.html';

function PartialsRun($templateCache) {

  'ngInject';

  /**
   *
   * @PRIVATE
   *
   */

  function cacheTemplates() {

    var templates = [{
      name: '$partials-filter-box.html',
      content: FilterBoxTemplate
    }, {
      name: '$partials-follow-box-social.html',
      content: FollowBoxSocialTemplate
    }];

    templates.forEach(function(template) {

      $templateCache.put(template.name, template.content);
    });
  }

  /**
   *
   * @RUN
   *
   */

  cacheTemplates();
}

export default PartialsRun;



// WEBPACK FOOTER //
// ./app/components/nn-partials/nn-partials.run.js